var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediaKit3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#F6C8E3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.08301 15.9993C8.08301 17.7665 8.17867 19.1353 8.41567 20.2017C8.65078 21.2596 9.01487 21.9733 9.5203 22.4787C10.0257 22.9842 10.7394 23.3482 11.7973 23.5834C12.8637 23.8203 14.2325 23.916 15.9997 23.916C17.7668 23.916 19.1357 23.8203 20.2021 23.5834C21.2599 23.3482 21.9736 22.9842 22.4791 22.4787C22.9845 21.9733 23.3486 21.2596 23.5837 20.2017C23.8207 19.1353 23.9163 17.7665 23.9163 15.9993C23.9163 14.2322 23.8207 12.8634 23.5837 11.797C23.3486 10.7391 22.9845 10.0254 22.4791 9.51997C21.9736 9.01455 21.2599 8.65045 20.2021 8.41534C19.1357 8.17835 17.7668 8.08268 15.9997 8.08268C14.2325 8.08268 12.8637 8.17835 11.7973 8.41534C10.7394 8.65045 10.0257 9.01455 9.5203 9.51997C9.01487 10.0254 8.65078 10.7391 8.41567 11.797C8.17867 12.8634 8.08301 14.2322 8.08301 15.9993Z",
    stroke: "#2D264B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 12.3887V19.6109M19.6109 15.2776V19.6109M12.3887 16.722V19.6109",
    stroke: "#2D264B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaKit3);
export default __webpack_public_path__ + "static/media/media-kit-3.a1b528859f44022d909a96fd07ee8d92.svg";
export { ForwardRef as ReactComponent };